import React, { useEffect, useState, useRef } from 'react';

const SelectFilters = props => {

    const institutionTypes = [
        {id: '1', literal: '20614'},
        {id: '2', literal: '20611'},
        {id: '3', literal: '20612'},
        {id: '4', literal: '20613'}
    ];
    const categoryTypes = [
        {id: '1', literal: '20714'},
        {id: '2', literal: '20715'},
        {id: '3', literal: '20716'}
    ];
    const challengesTypes = [
        {id: '1', literal: '20631'},
        {id: '2', literal: '20632'},
        {id: '3', literal: '20633'}
    ];
    const programmeTypes = [
        {id: '1', literal: '20525'},
        {id: '2', literal: '20526'},
        {id: '3', literal: '20527'}
    ];
    const publicationTypes = [
        {id: '1', literal: '20765'},
        {id: '2', literal: '20766'},
        {id: '3', literal: '20767'},
        {id: '4', literal: '20768'},
        {id: '5', literal: '20769'},
        {id: '6', literal: '20770'},
        {id: '7', literal: '20771'},
        {id: '8', literal: '20024'},
        {id: '9', literal: '20643'}
    ];
    const countryDropdownRef = useRef();
    const institutionDropdownRef = useRef();
    const [isCountryDropdown, setIsCountryDropdown] = useState(false);
    const [isInstitutionDropdown, setIsInstitutionDropdown] = useState(false);
    const [searchBarText, setSearchBarText] = useState("");

    // Handle dropdown when clicked outside of their container
	const onHandleDropdown = e => {
		if (countryDropdownRef.current && !countryDropdownRef.current.contains(e.target)) {
            setIsCountryDropdown(false);
		}

		if(institutionDropdownRef.current && !institutionDropdownRef.current.contains(e.target)) {
            setIsInstitutionDropdown(false);
		}
	}

    // sends country code to parent component
    const onClickCountry = (countryCode) => {
        return () => {
            props.onClickCountry(countryCode);
        }
    }

    // send institution id to parent component
    const onClickInstitution = (institutionId) => {
        return () => {
            props.onClickInstitution(institutionId);
        }
    }

    // Dropdown for country selector
	const onClickCountryDropdown = () => {
        setIsCountryDropdown(!isCountryDropdown);
	}

	// Dropdown for institution selector
	const onClickInstitutionDropdown = () => {
        setIsInstitutionDropdown(!isInstitutionDropdown);
	}

    //handles change event of search bar
    const onHandleChange = (e) => {
        setSearchBarText(e.target.value);
	}

    // handles on click on search bar either on icon or by enter keydown
    const onSearchClick = (e, text) => {
		if (e.keyCode == 13) {
			e.preventDefault();
            props.onSearchbarClick(text);
		}

		if (e.type == 'click') {
            props.onSearchbarClick(text);
		}
	}

    // handles the click on the X to clean the text
    const onClearClick = () => {
        if (searchBarText != "")
        {
            props.onSearchbarClick("");
            setSearchBarText("");
        }
    }

    useEffect(() => {
        // Open a listener for and mousedown event on body page to close any of the dropdowns
		document.addEventListener('mousedown', onHandleDropdown);
    }, [])

    /*componentWillUnmount() {

        // Clears a listener when component is unmounted
        document.removeEventListener('mousedown', this.onHandleChange);
    }*/

    // Each filter will only be painted if there is a callback function defined for it
    let filter1, filter2, filter3;
    
    if (props.onClickCountry)
    {
        if (props.filterCategory != "programmes")
        {
            // The dropdown will contain a list with countries
            filter1 = <div id="filter2" className={`filter--dropdown--wrapper ${isCountryDropdown ? 'viewOptions' : null}`} tabIndex="9">
                <div className="filter--dropdown--list" ref={countryDropdownRef}>
                    <p className="option-title" onClick={onClickCountryDropdown} >{props.literals.L20630}</p>
                    <ul className="filter--dropdown--options ">
                        {props.selectCountries && props.selectCountries.map((country) => (
                            <li key={country.code} onClick={onClickCountry(country)} >
                                <input type="checkbox" checked={props.selectedFilters.countries.find((countryFilter) => countryFilter.code == country.code) ? true : false} readOnly />
                                <label >{country.name == 'EU28' || country.name == 'EU27' ? `${country.name}` : `(${country.code}) ${country.name}`}</label>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        }
        else
        {
            filter1 = <div id="filter2" className={`filter--dropdown--wrapper ${isCountryDropdown ? 'viewOptions' : null}`} tabIndex="9">
                <div className="filter--dropdown--list" ref={countryDropdownRef}>
                    <p className="option-title" onClick={onClickCountryDropdown} >{props.literals.L20529}</p>
                    <ul className="filter--dropdown--options">
                        {props.selectCountries && props.selectCountries.map((organisation) => (
                            <li key={organisation.urlName} onClick={onClickCountry(organisation)} >
                                <input type="checkbox" checked={props.selectedFilters.organisations.find((orgFilter) => orgFilter.id == organisation.id) ? true : false} readOnly />
                                <label >{props.literals[`L${organisation.name}`]}</label>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        }
    }

    if (props.onClickInstitution)
    {
        let filterName = "";
        let filters = [];
        if (props.filterCategory == 'institution')
        {
            filterName = 'Institution Type';
            filters = institutionTypes;
        }
        else if (props.filterCategory == 'category')
        {
            filterName = props.literals.L20651;
            filters = categoryTypes;
        }
        else if (props.filterCategory == 'challenges')
        {
            filterName = props.literals.L20629;
            filters = challengesTypes;
        }
        else if (props.filterCategory == "programmes")
        {
            filterName = props.literals.L20524;
            filters = programmeTypes;
        }
        else if (props.filterCategory == "publication")
        {
            filterName = props.literals.L20774;
            filters = publicationTypes;
        }

        filter2 = <div id="filter1" className={`filter--dropdown--wrapper ${isInstitutionDropdown ? 'viewOptions' : null}`} tabIndex="8">
            <div className="filter--dropdown--list" ref={institutionDropdownRef}>
                <p className="option-title" onClick={onClickInstitutionDropdown} > {filterName} </p>
                <ul className="filter--dropdown--options">

                    {filters.map((filter) => (
                        <li key={filter.id} onClick={onClickInstitution({id: filter.id, literal: filter.literal})} >
                            <input type="checkbox" checked={props.selectedFilters.checks.find((array) => array.id == filter.id) ? true : false}  readOnly tabIndex="-1" />
                            <label className="" >{props.literals[`L${filter.literal}`]}</label>
                        </li>
                    ))}

                </ul>
            </div>
        </div>
    }

    if (props.onSearchbarClick)
    {
        filter3 = <div className="filter-text">
            <input onKeyDown={(e) => onSearchClick(e, searchBarText)} onChange={onHandleChange} id="search-input" type="text" tabIndex="7" className="" placeholder={props.literals.L378} value={searchBarText} />                
            {searchBarText != "" && (
                <button onClick={(e) => onClearClick()} id="policy-clear" type="button">
                    <i className="fa fa-times" aria-hidden="true"></i>
                </button>
            )}
            <button onClick={(e) => onSearchClick(e, searchBarText)} id="policy-search" type="button">
                <i className="fa fa-search" aria-hidden="true"></i>
            </button>
        </div>
    }

    return (
        <form className="row block--filter--wrapper ">
            {/* FILTERS */}
            {/* COUNTRY FILTER */}
            {filter1}
            {/* INSTITUTION TYPE FILTER || CATEGORY TYPE FILTER || CHALLENGES TYPE FILTER || PUBLICATION TYPE FILTER */}
            {filter2}
            {/* SEARCH FILTER */}
            {filter3}
        </form>
    );
}

export default SelectFilters;